
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 16","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.137 4.594A8.137 8.137 0 0018 2.66c-.703.317-1.406.527-2.11.598.774-.492 1.337-1.16 1.618-2.04-.738.423-1.512.739-2.356.88a4.257 4.257 0 00-1.23-.844 3.48 3.48 0 00-1.477-.317 3.65 3.65 0 00-1.828.493A3.837 3.837 0 009.281 2.8c-.351.563-.492 1.196-.492 1.829 0 .281 0 .562.07.844-1.511-.07-2.918-.422-4.254-1.125C3.27 3.68 2.18 2.766 1.265 1.605A3.657 3.657 0 00.739 3.47c0 .633.14 1.23.457 1.758.282.562.703.984 1.196 1.335-.598 0-1.16-.175-1.653-.492v.07c0 .88.282 1.653.844 2.32a3.544 3.544 0 002.11 1.302c-.352.07-.669.105-.985.105-.21 0-.457 0-.668-.035.211.738.633 1.336 1.266 1.828.632.492 1.336.703 2.18.703-1.372 1.055-2.919 1.582-4.606 1.582-.352 0-.633 0-.879-.035 1.688 1.125 3.586 1.652 5.66 1.652 2.145 0 4.043-.527 5.73-1.652a9.97 9.97 0 003.551-3.973c.809-1.546 1.23-3.199 1.23-4.886 0-.211-.034-.352-.034-.457z"}})])
          )
        }
      }
    